import NativeSelect from '@material-ui/core/NativeSelect';
import { withStyles } from '@material-ui/core/styles';

export default withStyles(theme => ({
  root: {
    width: '100%',
    height: '34px'
  },
  select: {
    height: '34px',
    width: '97%!important'
  },
  icon: {
    marginTop: '12px'
  }
}))(NativeSelect);



// WEBPACK FOOTER //
// ./src/components/shared/components/NativeSelectInput.js